import { render, staticRenderFns } from "./placard_add_upload.vue?vue&type=template&id=d78bf1d4&scoped=true"
import script from "./placard_add_upload.vue?vue&type=script&lang=js"
export * from "./placard_add_upload.vue?vue&type=script&lang=js"
import style0 from "./placard_add_upload.vue?vue&type=style&index=0&id=d78bf1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78bf1d4",
  null
  
)

export default component.exports